// extracted by mini-css-extract-plugin
export default {"noBorder":"FeeCard_noBorder__XTPD6"};